import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import Event, { eventShape } from "./Event"
import * as css from "./EventsList.module.css"

function EventList({ events, isUpcoming }) {
  return (
    <div className={css.root}>
      {events.map((eventProps, index) => {
        const {
          id,
          title,
          date,
          type,
          category,
          role,
          location,
          description,
          videoUrl,
          slug,
          thumbnail,
          buttons,
        } = eventProps

        return (
          <div
            className={cx(css.listItem, {
              [css.firstItem]: !!isUpcoming && index === 0,
              [css.lastItem]: !isUpcoming && index === events.length - 1,
            })}
            key={id}
          >
            <Event
              key={title}
              title={title}
              date={date}
              type={type}
              category={category}
              role={role}
              location={location}
              description={description}
              url={videoUrl}
              slug={slug}
              thumbnail={thumbnail}
              buttons={buttons}
              isUpcoming={isUpcoming}
            />
          </div>
        )
      })}
    </div>
  )
}

EventList.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape(eventShape)),
}

export default EventList
